export default __webpack_public_path__ + "5a15daa15148c106a58a877909675301.mp3";